// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page content'teki CSS stillerini ekle */

/* Intercom Widget Styles */
@keyframes intercom-lightweight-app-launcher {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes intercom-lightweight-app-gradient {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes intercom-lightweight-app-messenger {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  40% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

.intercom-lightweight-app {
  position: fixed;
  z-index: 2147483001;
  width: 0;
  height: 0;
  font-family: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.intercom-lightweight-app-gradient {
  position: fixed;
  z-index: 2147483002;
  width: 500px;
  height: 500px;
  bottom: 0;
  right: 0;
  pointer-events: none;
  background: radial-gradient(
    ellipse at bottom right,
    rgba(29, 39, 54, 0.16) 0%,
    rgba(29, 39, 54, 0) 72%);
  animation: intercom-lightweight-app-gradient 200ms ease-out;
}

.intercom-lightweight-app-launcher {
  position: fixed;
  z-index: 2147483003;
  padding: 0 !important;
  margin: 0 !important;
  border: none;
  bottom: 20px;
  right: 20px;
  max-width: 48px;
  width: 48px;
  max-height: 48px;
  height: 48px;
  border-radius: 50%;
  background: #080808;
  cursor: pointer;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16);
  transition: transform 167ms cubic-bezier(0.33, 0.00, 0.00, 1.00);
  box-sizing: content-box;
}

.intercom-lightweight-app-launcher:hover {
  transition: transform 250ms cubic-bezier(0.33, 0.00, 0.00, 1.00);
  transform: scale(1.1)
}

.intercom-lightweight-app-launcher:active {
  transform: scale(0.85);
  transition: transform 134ms cubic-bezier(0.45, 0, 0.2, 1);
}

.intercom-lightweight-app-launcher:focus {
  outline: none;
}

.intercom-lightweight-app-launcher-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 48px;
  transition: transform 100ms linear, opacity 80ms linear;
}

.intercom-lightweight-app-launcher-icon-open {
  opacity: 1;
  transform: rotate(0deg) scale(1);
}

.intercom-lightweight-app-launcher-icon-open svg {
  width: 24px;
  height: 24px;
}

.intercom-lightweight-app-launcher-icon-open svg path {
  fill: rgb(255, 255, 255);
}

/* reCAPTCHA Styles */
.g-recaptcha-response {
  width: 250px;
  height: 40px;
  border: 1px solid rgb(193, 193, 193);
  margin: 10px 25px;
  padding: 0px;
  resize: none;
  display: none;
}

/* Login Layout Styles */
.LoginLayout_h1__37fiS {
  color: #032983;
  font-size: 36px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
}

.LoginLayout_h2__1y0KC {
  font-size: 22px;
  font-weight: 400;
}

.LoginLayout_h2__1y0KC,
.LoginLayout_h3__D_uXO {
  color: #032983;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
}

.LoginLayout_h3__D_uXO {
  font-size: 14px;
  font-weight: 600;
}

.LoginLayout_regular__2JZOd {
  opacity: .8;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #6d809f;
  text-align: left;
}

.LoginLayout_LoginSidebar__2_Xz5 {
  height: 100%;
  background: no-repeat transparent 50%;
  background-size: cover;
  background-image: url(https://personelika.alo-tech.com/static/login/media/login-sidebar.e791131d.png);
  padding: 65px;
}

.LoginLayout_LoginSidebar_Title__1MAvw {
  font-weight: 500;
  font-size: 40px;
  color: #314469;
  width: 100%;
  text-align: center;
}

.LoginLayout_LoginSidebar_Title2__6KP0W {
  font-weight: 800;
  font-size: 64px;
  color: #314469;
  width: 100%;
  text-align: center;
}

.LoginLayout_LoginSidebar_SubTitle__29G5V {
  font-size: 16px;
  color: #314469;
  width: 100%;
  text-align: center;
  opacity: .7;
  margin-top: 11px;
}

.LoginLayout_LoginTemplate_Title__2jTDU {
  color: rgba(0, 41, 131, .8705882353);
  font-weight: 500;
  font-size: 48px;
  white-space: nowrap;
}

.LoginLayout_LoginTemplate_SubTitle__3F6xv {
  color: #6d809f;
  font-size: 16px;
  margin-top: 27px;
  height: 60px;
}

.LoginLayout_LoginTemplate__1blZW {
  background-color: #fff;
  padding-top: 76px;
  padding-bottom: 24px;
}

.LoginLayout_LoginTemplate__1blZW::-webkit-scrollbar {
  display: none;
}

.LoginLayout_LoginTemplateContainer__1w1Aa {
  max-width: 63%;
}

.LoginLayout_LoginTemplate_Icon__u8D7t {
  cursor: pointer;
  height: 70px;
  background: no-repeat transparent 0;
  background-size: contain;
  background-image: url(https://personelika.alo-tech.com/static/login/media/call-center.f150dafd.png);
  margin-bottom: 66px;
}

.LoginLayout_LoginTemplate_Alotech_Icon__15Q7J {
  cursor: pointer;
  height: 50px;
  background: no-repeat transparent 0;
  background-size: contain;
  background-image: url(https://personelika.alo-tech.com/static/login/media/alotech.f1fd100f.svg);
  margin-bottom: 66px;
  width: 300px;
}

.LoginLayout_LoginTemplate_Back__2wwZn {
  top: 8px;
  left: -80px;
  position: absolute;
  margin-bottom: 66px;
}

.LoginLayout_LoginTemplate_Back__2wwZn,
.LoginLayout_LoginTemplate_BackTitle__3BrP1 {
  height: 48px;
  width: 48px;
  cursor: pointer;
  background: no-repeat transparent 0;
  background-size: contain;
  background-image: url(https://personelika.alo-tech.com/static/login/media/back.b7289b80.svg);
}

.LoginLayout_LoginTemplate_BackTitle__3BrP1 {
  position: relative;
  margin-bottom: -10px;
  margin-right: 10px;
  display: none;
}

.LoginLayout_LoginTemplate_Children__2fFs- {
  position: relative;
}

.LoginLayout_Recaptcha_Text__gaZxo {
  align-self: center;
  font-size: 11px;
  color: #5e5e5e;
  width: calc(31.5vw - 48px);
}

/* Responsive Styles */
@media screen and (max-width: 900px) {
  .LoginLayout_LoginSidebar__2_Xz5 {
    display: none;
  }
  
  .LoginLayout_Recaptcha_Text__gaZxo {
    width: calc(63vw - 48px);
  }
  
  .LoginLayout_LoginTemplate__1blZW {
    padding-top: 36px;
    padding-bottom: 24px;
    width: 100vw;
  }
  
  .LoginLayout_LoginTemplate_Icon__u8D7t {
    margin-bottom: 36px;
  }
  
  .LoginLayout_LoginTemplateContainer__1w1Aa {
    height: calc(100% + 200px);
  }
}

@media screen and (max-width: 600px) {
  .LoginLayout_LoginTemplateContainer__1w1Aa {
    max-width: 100%;
  }
  
  .LoginLayout_LoginTemplate_BackTitle__3BrP1 {
    display: inline-block;
  }
  
  .LoginLayout_Recaptcha_Text__gaZxo {
    width: calc(100vw - 32px);
  }
}

@media screen and (max-width: 1400px) {
  .LoginLayout_LoginSidebar_Title__1MAvw {
    font-size: 34px;
  }
  
  .LoginLayout_LoginSidebar_SubTitle__29G5V {
    font-size: 14px;
    margin-top: -5px;
  }
}

@media screen and (max-width: 1250px) {
  .LoginLayout_LoginTemplate_SubTitle__3F6xv {
    height: 80px;
    margin-top: 0;
  }
}

/* Form Field Styles */
.FormField_h1__1eXk8 {
  color: #032983;
  font-size: 36px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
}

.FormField_h2__1uiT- {
  font-size: 22px;
  font-weight: 400;
}

.FormField_h2__1uiT-,
.FormField_h3__3XNvE {
  color: #032983;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
}

.FormField_h3__3XNvE {
  font-size: 14px;
  font-weight: 600;
}

.FormField_regular__3Q_Kz {
  opacity: .8;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #6d809f;
  text-align: left;
}

.FormField_fieldWrapper__2IpJh {
  display: inline-block;
  width: 100%;
}

.FormField_fieldWrapper__2IpJh:not(.FormField_outlined__2HSLg) {
  margin: 8px 0;
}

.FormField_fieldWrapper__2IpJh.FormField_captcha__Ry6dA {
  height: 0;
  margin: 0;
}

.FormField_textWrapper__32eUn {
  position: relative;
}

.FormField_textWrapper__32eUn .FormField_iconWrapper__2evnz {
  position: absolute;
  top: 25px;
  z-index: 1;
  right: 10px;
}

.FormField_checkboxWrapper__MQg7H {
  height: 50px;
  display: flex;
  align-items: center;
}

/* Input Field Styles */
.InputField_h1__1VRMc {
  font-size: 36px;
  font-weight: 600;
  line-height: normal;
}

.InputField_h1__1VRMc,
.InputField_h2__2rf8- {
  color: #032983;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
}

.InputField_h2__2rf8- {
  font-size: 22px;
  font-weight: 400;
  line-height: 1;
}

.InputField_h3__GACh3 {
  color: #032983;
  font-size: 14px;
  font-weight: 600;
}

.InputField_h3__GACh3,
.InputField_regular__10k9U {
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
}

.InputField_regular__10k9U {
  opacity: .8;
  font-size: 12px;
  font-weight: 400;
  color: #6d809f;
}

.InputField_InputField_PasswordVisibility__2KFH- {
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
}

.InputField_InputField_Error__12QO9 fieldset {
  border-color: #f02833 !important;
}

.InputField_InputField_Error__12QO9 label,
.InputField_InputField_Error__12QO9 p {
  color: #f02833 !important;
}

/* Login Common Styles */
.LoginCommon_h1__dbW1s {
  color: #032983;
  font-size: 36px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
}

.LoginCommon_h2__3P07x {
  font-size: 22px;
  font-weight: 400;
}

.LoginCommon_h2__3P07x,
.LoginCommon_h3__3brgl {
  color: #032983;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
}

.LoginCommon_h3__3brgl {
  font-size: 14px;
  font-weight: 600;
}

.LoginCommon_regular__tBuDD {
  opacity: .8;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #6d809f;
  text-align: left;
}

.LoginCommon_LoginCommon_Title__N8ftt {
  color: rgba(0, 41, 131, .8705882353);
  font-weight: 500;
  font-size: 64px;
}

.LoginCommon_LoginCommon_SubTitle__35GBN {
  color: #6d809f;
  font-size: 16px;
  margin-top: 27px;
  height: 50px;
}

.LoginCommon_LoginCommon_SignupWrapper__97P2d {
  text-align: center;
  width: 100%;
  margin-top: 51px;
  font-weight: 500;
  color: #6d809f;
  font-size: 18px;
}

.LoginCommon_LoginCommon_SignupWrapper__97P2d span {
  cursor: pointer;
  color: #002983;
  text-decoration: underline;
  font-weight: 600;
}

.LoginCommon_LoginCommon_SwitchWrapper__BI0LT {
  margin-top: 31px;
  margin-bottom: 11px;
  display: flex;
  width: 100%;
}

.LoginCommon_LoginCommon_SwitchWrapper__Text__UyR63 {
  font-size: 12px;
  color: #6d809f;
}

.LoginCommon_LoginCommon_SwitchWrapper__Switch__2s_l4 {
  margin-left: auto;
}

.LoginCommon_LoginCommon_Button__3KaUG {
  margin-top: 0 !important;
}

.LoginCommon_Recaptcha_Text__23JxM {
  position: fixed;
  bottom: 0;
  font-size: 11px;
  color: #5e5e5e;
  width: calc(31.5vw - 48px);
}

/* Responsive for LoginCommon */
@media screen and (min-height: 780px) {
  .LoginCommon_LoginCommon_Button__3KaUG {
    margin-top: 20px !important;
  }
}

@media screen and (max-width: 950px) {
  .LoginCommon_LoginCommon_SignupWrapper__97P2d {
    padding-bottom: 100px;
  }
}

@media screen and (max-width: 900px) {
  .LoginCommon_Recaptcha_Text__23JxM {
    width: calc(63vw - 48px);
  }
}

@media screen and (max-width: 600px) {
  .LoginCommon_Recaptcha_Text__23JxM {
    width: calc(100vw - 32px);
  }
}

/* Font Faces */
/* Font faces - using system fonts for now */
@font-face {
  font-family: Axiforma;
  src: local('Arial'), local('Helvetica'), local('sans-serif');
}

@font-face {
  font-weight: 100;
  font-family: Axiforma;
  src: local('Arial'), local('Helvetica'), local('sans-serif');
}

@font-face {
  font-weight: 500;
  font-family: Axiforma;
  src: local('Arial'), local('Helvetica'), local('sans-serif');
}

@font-face {
  font-weight: 600;
  font-family: Axiforma;
  src: local('Arial'), local('Helvetica'), local('sans-serif');
}

@font-face {
  font-weight: 700;
  font-family: Axiforma;
  src: local('Arial'), local('Helvetica'), local('sans-serif');
}

@font-face {
  font-weight: 800;
  font-family: Axiforma;
  src: local('Arial'), local('Helvetica'), local('sans-serif');
}

/* Global Styles */
#root {
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: Axiforma !important;
}

html {
  font-size: 14px;
  overflow: hidden;
  scroll-behavior: smooth;
}

body,
html {
  height: 100%;
}

body {
  background-color: #f0f0f0;
  color: #2b2b2b;
}

a {
  text-decoration: none;
  color: unset;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: block;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #6d809f;
}

::-webkit-scrollbar-track {
  box-shadow: none;
  border-radius: 10px;
  background: #cadbe5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kIAAkI;AACpI;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,QAAQ;EACR,oBAAoB;EACpB;;;4BAG0B;EAC1B,2DAA2D;AAC7D;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6EAA6E;EAC7E,gEAAgE;EAChE,uBAAuB;AACzB;;AAEA;EACE,gEAAgE;EAChE;AACF;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,sBAAsB;EACtB,qGAAqG;EACrG,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,wBAAwB;EACxB,mGAAmG;EACnG,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,wBAAwB;EACxB,+FAA+F;EAC/F,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,wBAAwB;EACxB,4FAA4F;AAC9F;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["/* Page content'teki CSS stillerini ekle */\n\n/* Intercom Widget Styles */\n@keyframes intercom-lightweight-app-launcher {\n  from {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes intercom-lightweight-app-gradient {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes intercom-lightweight-app-messenger {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.intercom-lightweight-app {\n  position: fixed;\n  z-index: 2147483001;\n  width: 0;\n  height: 0;\n  font-family: system-ui, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n\n.intercom-lightweight-app-gradient {\n  position: fixed;\n  z-index: 2147483002;\n  width: 500px;\n  height: 500px;\n  bottom: 0;\n  right: 0;\n  pointer-events: none;\n  background: radial-gradient(\n    ellipse at bottom right,\n    rgba(29, 39, 54, 0.16) 0%,\n    rgba(29, 39, 54, 0) 72%);\n  animation: intercom-lightweight-app-gradient 200ms ease-out;\n}\n\n.intercom-lightweight-app-launcher {\n  position: fixed;\n  z-index: 2147483003;\n  padding: 0 !important;\n  margin: 0 !important;\n  border: none;\n  bottom: 20px;\n  right: 20px;\n  max-width: 48px;\n  width: 48px;\n  max-height: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #080808;\n  cursor: pointer;\n  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16);\n  transition: transform 167ms cubic-bezier(0.33, 0.00, 0.00, 1.00);\n  box-sizing: content-box;\n}\n\n.intercom-lightweight-app-launcher:hover {\n  transition: transform 250ms cubic-bezier(0.33, 0.00, 0.00, 1.00);\n  transform: scale(1.1)\n}\n\n.intercom-lightweight-app-launcher:active {\n  transform: scale(0.85);\n  transition: transform 134ms cubic-bezier(0.45, 0, 0.2, 1);\n}\n\n.intercom-lightweight-app-launcher:focus {\n  outline: none;\n}\n\n.intercom-lightweight-app-launcher-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 48px;\n  height: 48px;\n  transition: transform 100ms linear, opacity 80ms linear;\n}\n\n.intercom-lightweight-app-launcher-icon-open {\n  opacity: 1;\n  transform: rotate(0deg) scale(1);\n}\n\n.intercom-lightweight-app-launcher-icon-open svg {\n  width: 24px;\n  height: 24px;\n}\n\n.intercom-lightweight-app-launcher-icon-open svg path {\n  fill: rgb(255, 255, 255);\n}\n\n/* reCAPTCHA Styles */\n.g-recaptcha-response {\n  width: 250px;\n  height: 40px;\n  border: 1px solid rgb(193, 193, 193);\n  margin: 10px 25px;\n  padding: 0px;\n  resize: none;\n  display: none;\n}\n\n/* Login Layout Styles */\n.LoginLayout_h1__37fiS {\n  color: #032983;\n  font-size: 36px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.LoginLayout_h2__1y0KC {\n  font-size: 22px;\n  font-weight: 400;\n}\n\n.LoginLayout_h2__1y0KC,\n.LoginLayout_h3__D_uXO {\n  color: #032983;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.LoginLayout_h3__D_uXO {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.LoginLayout_regular__2JZOd {\n  opacity: .8;\n  font-size: 12px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  color: #6d809f;\n  text-align: left;\n}\n\n.LoginLayout_LoginSidebar__2_Xz5 {\n  height: 100%;\n  background: no-repeat transparent 50%;\n  background-size: cover;\n  background-image: url(https://personelika.alo-tech.com/static/login/media/login-sidebar.e791131d.png);\n  padding: 65px;\n}\n\n.LoginLayout_LoginSidebar_Title__1MAvw {\n  font-weight: 500;\n  font-size: 40px;\n  color: #314469;\n  width: 100%;\n  text-align: center;\n}\n\n.LoginLayout_LoginSidebar_Title2__6KP0W {\n  font-weight: 800;\n  font-size: 64px;\n  color: #314469;\n  width: 100%;\n  text-align: center;\n}\n\n.LoginLayout_LoginSidebar_SubTitle__29G5V {\n  font-size: 16px;\n  color: #314469;\n  width: 100%;\n  text-align: center;\n  opacity: .7;\n  margin-top: 11px;\n}\n\n.LoginLayout_LoginTemplate_Title__2jTDU {\n  color: rgba(0, 41, 131, .8705882353);\n  font-weight: 500;\n  font-size: 48px;\n  white-space: nowrap;\n}\n\n.LoginLayout_LoginTemplate_SubTitle__3F6xv {\n  color: #6d809f;\n  font-size: 16px;\n  margin-top: 27px;\n  height: 60px;\n}\n\n.LoginLayout_LoginTemplate__1blZW {\n  background-color: #fff;\n  padding-top: 76px;\n  padding-bottom: 24px;\n}\n\n.LoginLayout_LoginTemplate__1blZW::-webkit-scrollbar {\n  display: none;\n}\n\n.LoginLayout_LoginTemplateContainer__1w1Aa {\n  max-width: 63%;\n}\n\n.LoginLayout_LoginTemplate_Icon__u8D7t {\n  cursor: pointer;\n  height: 70px;\n  background: no-repeat transparent 0;\n  background-size: contain;\n  background-image: url(https://personelika.alo-tech.com/static/login/media/call-center.f150dafd.png);\n  margin-bottom: 66px;\n}\n\n.LoginLayout_LoginTemplate_Alotech_Icon__15Q7J {\n  cursor: pointer;\n  height: 50px;\n  background: no-repeat transparent 0;\n  background-size: contain;\n  background-image: url(https://personelika.alo-tech.com/static/login/media/alotech.f1fd100f.svg);\n  margin-bottom: 66px;\n  width: 300px;\n}\n\n.LoginLayout_LoginTemplate_Back__2wwZn {\n  top: 8px;\n  left: -80px;\n  position: absolute;\n  margin-bottom: 66px;\n}\n\n.LoginLayout_LoginTemplate_Back__2wwZn,\n.LoginLayout_LoginTemplate_BackTitle__3BrP1 {\n  height: 48px;\n  width: 48px;\n  cursor: pointer;\n  background: no-repeat transparent 0;\n  background-size: contain;\n  background-image: url(https://personelika.alo-tech.com/static/login/media/back.b7289b80.svg);\n}\n\n.LoginLayout_LoginTemplate_BackTitle__3BrP1 {\n  position: relative;\n  margin-bottom: -10px;\n  margin-right: 10px;\n  display: none;\n}\n\n.LoginLayout_LoginTemplate_Children__2fFs- {\n  position: relative;\n}\n\n.LoginLayout_Recaptcha_Text__gaZxo {\n  align-self: center;\n  font-size: 11px;\n  color: #5e5e5e;\n  width: calc(31.5vw - 48px);\n}\n\n/* Responsive Styles */\n@media screen and (max-width: 900px) {\n  .LoginLayout_LoginSidebar__2_Xz5 {\n    display: none;\n  }\n  \n  .LoginLayout_Recaptcha_Text__gaZxo {\n    width: calc(63vw - 48px);\n  }\n  \n  .LoginLayout_LoginTemplate__1blZW {\n    padding-top: 36px;\n    padding-bottom: 24px;\n    width: 100vw;\n  }\n  \n  .LoginLayout_LoginTemplate_Icon__u8D7t {\n    margin-bottom: 36px;\n  }\n  \n  .LoginLayout_LoginTemplateContainer__1w1Aa {\n    height: calc(100% + 200px);\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .LoginLayout_LoginTemplateContainer__1w1Aa {\n    max-width: 100%;\n  }\n  \n  .LoginLayout_LoginTemplate_BackTitle__3BrP1 {\n    display: inline-block;\n  }\n  \n  .LoginLayout_Recaptcha_Text__gaZxo {\n    width: calc(100vw - 32px);\n  }\n}\n\n@media screen and (max-width: 1400px) {\n  .LoginLayout_LoginSidebar_Title__1MAvw {\n    font-size: 34px;\n  }\n  \n  .LoginLayout_LoginSidebar_SubTitle__29G5V {\n    font-size: 14px;\n    margin-top: -5px;\n  }\n}\n\n@media screen and (max-width: 1250px) {\n  .LoginLayout_LoginTemplate_SubTitle__3F6xv {\n    height: 80px;\n    margin-top: 0;\n  }\n}\n\n/* Form Field Styles */\n.FormField_h1__1eXk8 {\n  color: #032983;\n  font-size: 36px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.FormField_h2__1uiT- {\n  font-size: 22px;\n  font-weight: 400;\n}\n\n.FormField_h2__1uiT-,\n.FormField_h3__3XNvE {\n  color: #032983;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.FormField_h3__3XNvE {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.FormField_regular__3Q_Kz {\n  opacity: .8;\n  font-size: 12px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  color: #6d809f;\n  text-align: left;\n}\n\n.FormField_fieldWrapper__2IpJh {\n  display: inline-block;\n  width: 100%;\n}\n\n.FormField_fieldWrapper__2IpJh:not(.FormField_outlined__2HSLg) {\n  margin: 8px 0;\n}\n\n.FormField_fieldWrapper__2IpJh.FormField_captcha__Ry6dA {\n  height: 0;\n  margin: 0;\n}\n\n.FormField_textWrapper__32eUn {\n  position: relative;\n}\n\n.FormField_textWrapper__32eUn .FormField_iconWrapper__2evnz {\n  position: absolute;\n  top: 25px;\n  z-index: 1;\n  right: 10px;\n}\n\n.FormField_checkboxWrapper__MQg7H {\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n/* Input Field Styles */\n.InputField_h1__1VRMc {\n  font-size: 36px;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.InputField_h1__1VRMc,\n.InputField_h2__2rf8- {\n  color: #032983;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.InputField_h2__2rf8- {\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.InputField_h3__GACh3 {\n  color: #032983;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.InputField_h3__GACh3,\n.InputField_regular__10k9U {\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.InputField_regular__10k9U {\n  opacity: .8;\n  font-size: 12px;\n  font-weight: 400;\n  color: #6d809f;\n}\n\n.InputField_InputField_PasswordVisibility__2KFH- {\n  font-weight: 500;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.InputField_InputField_Error__12QO9 fieldset {\n  border-color: #f02833 !important;\n}\n\n.InputField_InputField_Error__12QO9 label,\n.InputField_InputField_Error__12QO9 p {\n  color: #f02833 !important;\n}\n\n/* Login Common Styles */\n.LoginCommon_h1__dbW1s {\n  color: #032983;\n  font-size: 36px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.LoginCommon_h2__3P07x {\n  font-size: 22px;\n  font-weight: 400;\n}\n\n.LoginCommon_h2__3P07x,\n.LoginCommon_h3__3brgl {\n  color: #032983;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n.LoginCommon_h3__3brgl {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.LoginCommon_regular__tBuDD {\n  opacity: .8;\n  font-size: 12px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  color: #6d809f;\n  text-align: left;\n}\n\n.LoginCommon_LoginCommon_Title__N8ftt {\n  color: rgba(0, 41, 131, .8705882353);\n  font-weight: 500;\n  font-size: 64px;\n}\n\n.LoginCommon_LoginCommon_SubTitle__35GBN {\n  color: #6d809f;\n  font-size: 16px;\n  margin-top: 27px;\n  height: 50px;\n}\n\n.LoginCommon_LoginCommon_SignupWrapper__97P2d {\n  text-align: center;\n  width: 100%;\n  margin-top: 51px;\n  font-weight: 500;\n  color: #6d809f;\n  font-size: 18px;\n}\n\n.LoginCommon_LoginCommon_SignupWrapper__97P2d span {\n  cursor: pointer;\n  color: #002983;\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n.LoginCommon_LoginCommon_SwitchWrapper__BI0LT {\n  margin-top: 31px;\n  margin-bottom: 11px;\n  display: flex;\n  width: 100%;\n}\n\n.LoginCommon_LoginCommon_SwitchWrapper__Text__UyR63 {\n  font-size: 12px;\n  color: #6d809f;\n}\n\n.LoginCommon_LoginCommon_SwitchWrapper__Switch__2s_l4 {\n  margin-left: auto;\n}\n\n.LoginCommon_LoginCommon_Button__3KaUG {\n  margin-top: 0 !important;\n}\n\n.LoginCommon_Recaptcha_Text__23JxM {\n  position: fixed;\n  bottom: 0;\n  font-size: 11px;\n  color: #5e5e5e;\n  width: calc(31.5vw - 48px);\n}\n\n/* Responsive for LoginCommon */\n@media screen and (min-height: 780px) {\n  .LoginCommon_LoginCommon_Button__3KaUG {\n    margin-top: 20px !important;\n  }\n}\n\n@media screen and (max-width: 950px) {\n  .LoginCommon_LoginCommon_SignupWrapper__97P2d {\n    padding-bottom: 100px;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .LoginCommon_Recaptcha_Text__23JxM {\n    width: calc(63vw - 48px);\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .LoginCommon_Recaptcha_Text__23JxM {\n    width: calc(100vw - 32px);\n  }\n}\n\n/* Font Faces */\n/* Font faces - using system fonts for now */\n@font-face {\n  font-family: Axiforma;\n  src: local('Arial'), local('Helvetica'), local('sans-serif');\n}\n\n@font-face {\n  font-weight: 100;\n  font-family: Axiforma;\n  src: local('Arial'), local('Helvetica'), local('sans-serif');\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: Axiforma;\n  src: local('Arial'), local('Helvetica'), local('sans-serif');\n}\n\n@font-face {\n  font-weight: 600;\n  font-family: Axiforma;\n  src: local('Arial'), local('Helvetica'), local('sans-serif');\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: Axiforma;\n  src: local('Arial'), local('Helvetica'), local('sans-serif');\n}\n\n@font-face {\n  font-weight: 800;\n  font-family: Axiforma;\n  src: local('Arial'), local('Helvetica'), local('sans-serif');\n}\n\n/* Global Styles */\n#root {\n  height: 100%;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: Axiforma !important;\n}\n\nhtml {\n  font-size: 14px;\n  overflow: hidden;\n  scroll-behavior: smooth;\n}\n\nbody,\nhtml {\n  height: 100%;\n}\n\nbody {\n  background-color: #f0f0f0;\n  color: #2b2b2b;\n}\n\na {\n  text-decoration: none;\n  color: unset;\n}\n\n::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n  display: block;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background: #6d809f;\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: none;\n  border-radius: 10px;\n  background: #cadbe5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
